import api from './api';
import type { InventoryDashboard } from '../types/venue';

const inventoryDashboardService = {
  getDashboard: async (venueId: string): Promise<InventoryDashboard> => {
    const response = await api.get(`/admin/venue/${venueId}/inventory/dashboard`);
    return response.data;
  },
};

export default inventoryDashboardService;
